import React, { Fragment } from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";

export const Template = (props: templates.ReusableContentBlockPreview) => (
    <PageSkeleton
        title={t`Reusable Content: ${props.object.admin_name}`}
        language={null}
        alternate_pages={[]}
    >
        <StreamField
            tagName={Fragment}
            components={toolboxComponents}
            value={props.object.content.value}
        />
    </PageSkeleton>
);
